module.exports = __webpack_public_path__ + "img/terry-min.6362becc.png";